// States
const servicesState = (function states() {
    return {
        labelList: [],
        isSpecialAbility: null,
        isPetFriendly: null
    }
})()

export default servicesState;